import React, { useEffect } from 'react';

const Speakers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const speakersList = [
    { name: "Speaker TBA", role: "Keynote Speaker", company: "Industry Leader" },
    { name: "Speaker TBA", role: "Panelist", company: "Tech Executive" },
    { name: "Speaker TBA", role: "Workshop Lead", company: "HR Professional" },
    { name: "Speaker TBA", role: "Guest Speaker", company: "Entrepreneur" },
    { name: "Speaker TBA", role: "Panelist", company: "Marketing Director" },
    { name: "Speaker TBA", role: "Panelist", company: "Finance Expert" },
    { name: "Speaker TBA", role: "Workshop Lead", company: "Career Coach" },
    { name: "Speaker TBA", role: "Keynote Speaker", company: "Global Leader" },
  ];

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">Our Speakers</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> Speakers
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="text-center">
            <div className="eyebrow" style={{justifyContent: 'center'}}>The Lineup</div>
            <h2 className="section-title">2026 Speakers</h2>
            <p className="section-body" style={{maxWidth: 600, margin: '0 auto'}}>
              We are curating an incredible lineup of industry leaders, innovators, and visionaries to share their insights and experiences. Stay tuned as we announce our official speakers.
            </p>
          </div>

          <div className="speakers-grid mt-12">
            {speakersList.map((speaker, i) => (
              <div key={i} className="speaker-card">
                <div 
                  className="speaker-card__photo-placeholder"
                  style={{
                    height: '280px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, var(--blue-light), #d0e8f7)',
                    color: 'var(--blue)'
                  }}
                >
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div className="speaker-card__info text-center">
                  <h3 className="speaker-card__name">{speaker.name}</h3>
                  <div className="speaker-card__role">{speaker.role}</div>
                  <div className="speaker-card__company">{speaker.company}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Speakers;
